// DS: i8.2
import React from 'react';
import IconWrap from '../../IconWrap';
const Info = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8 7C8.51284 7 8.93551 7.38604 8.99327 7.88338L9 8V11C9 11.5523 8.55228 12 8 12C7.48716 12 7.06449 11.614 7.00673 11.1166L7 11V8C7 7.44772 7.44772 7 8 7Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8 4C8.55228 4 9 4.44772 9 5C9 5.51284 8.61396 5.93551 8.11662 5.99327L8 6L7.88338 5.99327C7.38604 5.93551 7 5.51284 7 5C7 4.44772 7.44772 4 8 4Z"
    })));
Info.displayName = 'Info';
export default Info;
